const DEFAULT_MAX_SIZE = 10;
const BYTES = 1024;

// Кастомное правило для проверки размера файла
export default function maxFileSizeValidator(files, args = DEFAULT_MAX_SIZE) {
	const fileList = files?.value?.fileList;
	if (!fileList) return true;

	const file = files?.value?.fileList[0];
	const fileInstance = files?.value?.files[0];
	const fileSize = file?.size || 0;
	const maxSizeParam = args || args[0];
	const maxSize = maxSizeParam * BYTES * BYTES; // MB → Bytes

	if (fileSize > maxSize && fileInstance) {
		fileInstance?.removeFile();
		alert(`Файл "${file.name}" не принят (превышен максимальный размер ${maxSizeParam} МБ)`);
	}

	return fileSize <= maxSize;
}
